
const Content = [
  {
    templeHeading: "Famous temples in India",
    templeSubHeading: "Explore India’s iconic spiritual landmarks",
    serviceHeading: "Crafted Services, Just for You",
    serviceSubHeading: "Tailored solutions to meet your unique needs",
    stateHeading: "Explore temples by state",
    travelHeading: "Seamless Travel Solutions",
    travelSubHeading: "Travel smooth. Travel smart",
    aboutHeading: "Meet our",
    aboutsubHeading: "Founders",

    contactHeading: "Contact Us",
    careerHeading: "Career",
    contactsubHeading: "We’d love to hear from you! Whether you have a question, want to suggest a temple to be featured, or are interested in collaborating, your input is always welcome.",
    lockerHeading: "Rent a locker",
    contactGetInTouch: "Get in touch",
    contactFromHeading: "We’d like to hear from you",
    spanHeading: "Visiting the temple and need a safe place for your belongings? Our locker rental service provides a convenient and trustworthy solution.",
    paraHeading: "We are currently operational at Shri Mata Vaishno Devi and other major temples, with ongoing expansion to additional locations.",
    scheduleHeading: "Locker Allocation and Scheduling",
    testimonialHeading: "Our client testimonial",
    videoHeading: "Quick Tour of Our Smart Lockers",
    templeData: [
      { image: '/assets/tample/tample1.svg', name: 'Somnath' },
      { image: '/assets/tample/tample2.svg', name: 'Kedarnath' },
      { image: '/assets/tample/tample3.svg', name: 'Vaishno Devi' },
      { image: '/assets/tample/tample4.svg', name: 'Gangotri' },
      { image: '/assets/tample/tample5.svg', name: 'Dwarkadhish' },
      { image: '/assets/tample/tample6.svg', name: 'Akshardham' },
      { image: '/assets/tample/tample7.svg', name: 'Tirupathi Balaji' },
      { image: '/assets/tample/tample8.svg', name: 'Khamakhya' },
      { image: '/assets/tample/tample9.svg', name: 'Kashi Vishwanath' },
      { image: '/assets/tample/tample10.svg', name: 'Meenakshi Amman' },
    ],
    serviceData: [
      { image: '/assets/service-icon/icon1.svg', name: 'Reunite band', link: 'reunite-service' },
      { image: '/assets/service-icon/icon2.svg', name: 'Rent a locker', link: 'locker' },
      { image: '/assets/service-icon/icon3.svg', name: 'Yatri pack', link: 'coming-soon' },
      { image: '/assets/service-icon/icon4.svg', name: 'My plans', link: 'coming-soon' },
      { image: '/assets/service-icon/icon5.svg', name: 'Souvenir', link: 'https://shop.mandir.wiki/' },
      { image: '/assets/service-icon/icon6.svg', name: 'VR Darshan', link: 'vr-darshan', },
      { image: '/assets/service-icon/icon7.png', name: 'Navi stick', link: 'navi-stick', },
      { image: '/assets/service-icon/icon8.png', name: 'Sarthi service', link: 'sarthi-service', },
    ],
    stateData: [
      {
        id: 1,
        title: "Hyderabad",
        image: "/assets/maps/map1.svg",
      },
      {
        id: 2,
        title: "Karnataka",
        image: "/assets/maps/map2.svg",
      },
      {
        id: 3,
        title: "Uttrakhand",
        image: "/assets/maps/map3.svg",
      },
      {
        id: 4,
        title: "Madhya Pradesh",
        image: "/assets/maps/map4.svg",
      },
      {
        id: 5,
        title: "Hyderabad",
        image: "/assets/maps/map1.svg",
      },
      {
        id: 6,
        title: "Karnataka",
        image: "/assets/maps/map2.svg",
      },


    ],


    travelData: [
      {
        title: "Hotel",
        image: "/assets/booking/hotel.svg",
      },

      {
        title: "Boat Ride",
        image: "/assets/booking/boat.svg",
      },

      {
        title: "Flight Booking",
        image: "/assets/booking/flight.svg",
      },

      {
        title: "Cabs",
        image: "/assets/booking/cab.svg",
      },

    ],

    aboutbanner: [
      {
        title: "Our Purpose and Vision",
        para: ["Mandirwiki is a digital sanctuary celebrating the rich tapestry of temples across India and beyond. Our mission is to document, preserve, and share the spiritual, historical, and architectural heritage of mandirwiki with the world.",<br />,<p></p>,"We aim to create the most comprehensive and accessible encyclopaedia of temples — from ancient shrines nestled in remote villages to iconic spiritual landmarks known globally. Each entry is curated with deep respect for tradition and authenticity, combining historical research, local insights, and community contributions.",<br />,<p></p>,"Whether you're a devotee, historian, traveler, or cultural enthusiast, Mandirwiki is your gateway to exploring the divine stories, festivals, rituals, and legends that make every temple unique.",<br />,<p></p>,"Join us in preserving the legacy of mandirwiki for future generations."],
      },
    ],

    

    founderData: [
      {
        title: "Deepak Kumar",
        subheading: "Founder and CEO",
        para: ["An alumnus of IIT Delhi with a management degree and a master’s in Computer Science from BITS Pilani, Deepak brings over two decades of extensive experience in IT infrastructure, Data Centers, and Cloud technologies. Motivated by a personal mission to make temple visits more accessible for his parents, he is now on a journey to extend this convenience to every Indian by building a transformative platform for pilgrimage tourism.",<br/>,<p></p>,"Deepak is the Founder and CEO of mandirwiki. An avid traveler with an enduring love for tea, he is known for his dynamic personality— always engaging and memorable."],
      },
      {
        title: "Anand Mishra",
        subheading: "Co-Founder and CTO",
        para: ["I'm Anand Mishra, the Co-Founder and CTO of Arixpower India Pvt. Ltd., where we are committed to revolutionizing pilgrimage experiences through innovative technology.",<br/>,<p></p>,"Hailing from Varanasi, the spiritual heart of India, I hold a B.Tech degree from BBDNIIT, Lucknow, and bring with me over 8 years of experience working with dynamic startups across sectors such as Solar Technology, Electric Vehicles (EV), and Software Development."],
      },
    ],

      strength : [
      {
         id: "01",
         text: "Served more than 1M+ users since November 2024",
      },
      {
         id: "02",
         text: "WhatsApp and Chatbot facility available",
      },
      {
         id: "03",
         text: "Efficient Crowd Management",
      },
      {
         id: "04",
         text: "Accessible through our app and website",
      }
   ],


   schedulingList : [
      {
         point: "Select your locker and reserve it in minutes",
      },
      {
         point: "Rent by the day, week, or month",
      },
      {
         point: "24/7 surveillance and personal access codes",
      },
      {
         point: "Select your locker and reserve it in minutes",
      },
      
   ]

    

  },
]





export default Content;
